import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { ProductUnitsTab } from './product-units-tab';
import { v2Component } from '../../../index';
import { ToastContainer } from 'react-toastify';

export function initProductUnitsTab(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('product-units-tab');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          element.setAttribute(k, o[k]);
        });
      };

      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ProductUnitsTab {...dataset} setRootAttributes={setRootAttributes} />
            </TenantContext.Provider>,
          ),
        );
        const event = new CustomEvent('change');
        element.dispatchEvent(event);
      };

      bootstrap();
    }
  });
}
